import config from '@/utils/Config'
import {get, post } from '@/utils/request'

export function getUserInfo(params = {}) {
    return get(config.BASE_URL, config.getUesrInfoUrl, params)
}

export function getCatchphraseList(params = {}) {
    return get(config.BASE_URL, config.getCatchphraseUrl, params)
}

export function upUserInfo(params = {}) {
    return post(config.BASE_URL, config.upUserInfo, params)
}